import { render, staticRenderFns } from "./CmgUpdatePasswordModal.vue?vue&type=template&id=33145254&scoped=true&lang=pug"
import script from "./cmg-update-password-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-update-password-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgUpdatePasswordModal.vue?vue&type=style&index=0&id=33145254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33145254",
  null
  
)

export default component.exports